import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMatches, fetchMessages, selectMatch } from "../../redux/actions/matchActions";
import { setActiveTabMatch } from "../../redux/actions/dashboardActions";
import PrestataireCardLike from "../PrestataireCardLike";
import ChatConversation from "../ChatConversation";
import FinishProjectModal from "../FinishProjectModal";

const SelectedPresta = ({ projet }) => {
    const dispatch = useDispatch();
    const { list, selectedMatch } = useSelector((state) => state.match);
    const { token } = useSelector((state) => state.auth);
    const { activeTabMatch } = useSelector((state) => state.dashboard);
    const usersOnline = useSelector((state) => state.online.usersOnline);

    const [showFinishModal, setShowFinishModal] = useState(false);

    const [selectedMatchPresta, setSelectedMatchPresta] = useState(null);
    const containerStyle = { display: "flex", flexDirection: "column", gap: "15px", margin: "auto", alignItems: "center" };
    const tabBar = {
        display: "flex",
        gap: "12px",
        marginTop: "20px",
        marginBottom: "15px",
        paddingBottom: "8px",
        overflowX: "auto",
        whiteSpace: "nowrap",
        scrollbarWidth: "none",       // Firefox
        msOverflowStyle: "none"       // IE/Edge
    };
    const tabButton = (tab) => ({
        padding: "8px 12px",
        cursor: "pointer",
        borderRadius: "6px",
        background: activeTabMatch === tab ? "#007bff" : "#f1f1f1",
        color: activeTabMatch === tab ? "white" : "#333",
        border: "none",
        flexShrink: 0,                   // IMPORTANT pour scroll horizontal
        fontSize: "14px"
    });
    const badge = (online) => ({
        display: "flex",
        alignItems: "center",
        gap: "6px",
        background: online ? "#d4f8d4" : "#f0f0f0",
        color: online ? "#258f25" : "#555",
        border: `1px solid ${online ? "#42c442" : "#aaa"}`,
        padding: "4px 8px",
        borderRadius: "6px",
        fontSize: "13px",
        margin: "auto",
        width: "fit-content"
    });
    useEffect(() => {
        if (projet?.idProjetClient) {
            dispatch(fetchMatches(token, projet.idProjetClient));
        }
    }, [dispatch, token, projet?.idProjetClient]);

    useEffect(() => {
        if (!projet?.selectedPresta || !list?.length) return;

        const match = list.find(
            (m) =>
                m.prestataire.idUser ===
                projet.selectedPresta.idUser
        );

        if (match) {
            setSelectedMatchPresta(match);
            dispatch(selectMatch(match));
        }
    }, [list, projet?.selectedPresta,dispatch]);

    const selectedOnline =
        selectedMatch &&
        usersOnline[selectedMatch.prestataire?.idUser] === true;

    return (
        <div style={containerStyle}>
            {selectedMatch? (
                <>
                    {
                        selectedMatch.projet.statusProjetClient === "prestataire_selected" && (
                            <button className="btn-primary" onClick={() => setShowFinishModal(true)}>
                                Terminer le projet</button>
                        )
                    }
                    {activeTabMatch !== "prestataire" &&
                        (<>
                            <span style={badge(selectedOnline)}>
                                {selectedOnline ? "En ligne" : "Hors ligne"}
                            </span>
                            <h2 style={{ margin: "auto", textAlign: "center" }}>
                                {selectedMatch.prestataire.raisonSocialePrestataire}
                            </h2>
                        </>
                        )
                    }
                    {
                        <div style={tabBar}>
                            <button style={tabButton("prestataire")} onClick={() => dispatch(setActiveTabMatch("prestataire"))}>👤 Prestataire</button>
                            <button style={tabButton("chat")} onClick={() => dispatch(setActiveTabMatch("chat"))}>💬 Conversation</button>
                            {/* {selectedOnline && (
                                <button onClick={handleCall}>📞 Appel vidéo</button>
                            )} */}
                        </div>
                    }
                    {activeTabMatch === "prestataire" && (
                        <PrestataireCardLike
                            prestataire={selectedMatch.prestataire}
                            projet={selectedMatch.projet}
                            apiUrl={process.env.REACT_APP_API_URL}
                            onLike={null}
                            onPass={null}
                            isReceivedLike={false}
                            isAlreadyMatched={true}
                        />
                    )}

                    {activeTabMatch === "chat" && (
                        <ChatConversation
                            toUserId={selectedMatch.prestataire.idUser}
                            onMessageSent={() => dispatch(fetchMessages(token, selectedMatch.id))}
                        />
                    )}
                    {showFinishModal && (
                        <FinishProjectModal
                            idProjet={selectedMatch.projet.idProjetClient}
                            token={token}
                            onClose={() => setShowFinishModal(false)}
                            onSuccess={() => {
                                dispatch(fetchMatches(token));
                            }}
                        />
                    )}
                </>


            ) : (
                <p>Aucun prestataire choisi pour ce projet</p>
            )}


        </div>
    );
};

export default SelectedPresta;
